const style = {
    root: {
        // width: '100%',
        flexGrow: 1
    },
    
    button: {
        width: '96px',
        height: '40px',
        // marginRight: '20px',
        marginRight:'11px',
        marginTop : "10px",
        fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
    },
    helpText: {
        color: '#304d63',
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'right',
        float: 'right'
    },
    finishButton: {
       /* width: '15%',*/
        marginTop : "10px",
        height: '40px',
        // marginRight: '20px',
        marginRight:'11px',
        fontSize:'13px',
        fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
    },
    viewProgSum: {
        /* width: '15%',*/
         marginTop : "10px",
         height: '40px',
         fontSize:'13px',
         marginRight : '11px',
        fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
        //  marginLeft:'20px'
     },
    questionTitleText: {
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
        lineHeight: '16px',
        marginBottom: '9px',
        fontWeight:'bold',
        fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
    },
    rowText: {
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
        lineHeight: '16px',
        fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
    },
    progress: {
        width: '100%',
        marginTop: '24px',
        height: '10px',
        backgroundColor: '#f2f2f2',
        color: '#1a2c40 !important',
        marginBottom: '34px'
    },
    pbottomStyle: {
        marginTop: '34px',
        paddingBottom: '10px'
    },
    disabledButton: {
        backgroundColor: '#f0f0f1',
        color: '#b4b4bb',
        width: '96px',
        height: '40px',
        // marginRight: '20px',
        marginRight:'11px',
        marginTop : "10px",
        fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
    },
    textField: {
        width: '100%',
        //height: '56px',
        //backgroundColor: '#f1f1f1',
        color: '#19191d',
        borderRadius: '4px',
        marginBottom:'10px'
    },
    hyperText : {
        color:'#1a2c40',
        cursor: 'pointer',
        fontWeight : 'bold',
        borderBottom: '1px solid #1a2c40',
        // paddingLeft:'5px'
    },
    hyperTextScreen3 : {
        color:'#1a2c40',
        cursor: 'pointer',
        fontWeight : 'bold',
        borderBottom: '1px solid #1a2c40',
        paddingLeft:'5px',
        fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
    },

    pt_none : {
        pointerEvents : 'none'
    },

    pt_auto : {
        pointerEvents:  'auto'
    },
    medicareGrid:{
        border:'1px solid lightgray',
        borderRadius: '10px',
        display: 'flex',
        padding: '20px',
        width:'100%'
    },
    medicareBtn:{
        marginLeft: '20px',
        backgroundColor: 'white',
        border: '1px solid orange',
        borderRadius: '5px',
        padding:'5px 15px',
        fontWeight: '700',
        width:'110px',
        display:'flex',
        alignItems: 'center',
        height:'48px'
    },
    alert: {
        opacity: 1,
        transition: 'opacity 0.5s ease-in-out'
    },
    alerthidden: {
        opacity: 0,
        transition:'opacity 0.5s ease-in-out'
      }
}  
export default style;